import $ from "jquery"
import InputMask from 'react-input-mask'
import React, {useEffect, useState, useMemo, useCallback} from 'react'
import * as yup from 'yup'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import axios from 'axios'
import {toast} from 'react-toastify'
import styles from './styles.module.scss'
import parse from 'html-react-parser'
import { InvisibleSmartCaptcha } from '@yandex/smart-captcha'

// eslint-disable-next-line no-var
//var _ymaps = null, _ymaps2 = null;

const FormAcceptPolicy = ({setSuccessSend, setActiveForm, checkDomenNameState, email, captchaSiteKey}) => {
  const [number, setNumber] = useState('')
  const [errorNumber, setErrorNumber] = useState(false)
  const [serial, setSerial] = useState('')
  const [errorSerial, setErrorSerial] = useState(false)
  const [errorAddress, setErrorAddress] = useState('')
  const [errorAddressReg, setErrorAddressReg] = useState('')
  const [success, setSuccess] = useState(false)
  const [blurSuccess, setBlurSuccess] = useState(false)
  const [reg, setReg] = useState(false)

  const [token, setToken] = useState('')
  const [visible, setVisible] = useState(false)
  const handleChallengeHidden = useCallback(() => setVisible(false), [])
  const handleButtonClick = () => setVisible(true)

// test
  const [addressProcess, setAddressProcess] = useState(false)
  const [addressProcessReg, setAddressRegProcess] = useState(false)
  const [coordPopup, setCoordPopup] = useState({top: 0, left: 0});
  const [suggestions, setSuggestions] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState({
    town: '',
    street: '',
    house: ''
  });
  const [coordPopupReg, setCoordPopupReg] = useState({top: 0, left: 0});
  const [suggestionsReg, setSuggestionsReg] = useState([]);
  const [selectedAddressReg, setSelectedAddressReg] = useState({
    town: '',
    street: '',
    house: ''
  });
  const addressPoles = ['country','locality','street','house']
  const stylePositionPopup = (coord) => {
    return {top: coord.top + "px", left: coord.left + "px"}
  }
  const handleInputChangeAddress = async (type, target, address) => {
    if(['town', 'street', 'house'].includes(type)) {
      address[type] = target.value;
      setSelectedAddress(address);
      let res = checkAddress(selectedAddress)
      if (res.error.length > 0) {
        setErrorAddress(res.error)
      } else {
        setErrorAddress('')
      }
      const _address_all = (address?.town ? address.town + ', ' : '') + (address?.street ? address.street + ', ' : '') + (address?.house ? address.house : '')
      if (addressProcess) {
        setAddressProcess(false)
        try {
          const response = await axios.get('https://geocode-maps.yandex.ru/1.x/', {
            params: {
              apikey: 'cdfea19a-a15c-468e-a06f-79c567b491dc',
              geocode: _address_all,
              format: 'json'
            }
          });

          const { GeoObjectCollection } = response.data.response;
          const suggestions = GeoObjectCollection.featureMember.map(feature => {
            const { Address } = feature.GeoObject.metaDataProperty.GeocoderMetaData;
            const _value = {}
            for(const item of Address.Components) {
              if(addressPoles.includes(item.kind)) {
                _value[item.kind] = item.name
              }
            }
            return {
              value: {
                //region: _value?.country ?? '',
                town: (_value?.country ? _value?.country + (_value?.locality ? ', ' : '') : '') + (_value?.locality ? _value?.locality : ''),
                street: _value?.street ?? '',
                house: _value?.house ?? ''
              },
              label: (_value?.country ? _value?.country + ', ' : '') + (_value?.locality ? _value?.locality + ', ' : '') + (_value?.street ? _value?.street + ', ' : '') + (_value?.house ? _value?.house : '')
          };
          });
          let _height = target.offsetHeight;
          let _posX = target.offsetTop;
          let _posY = target.offsetLeft;
          setCoordPopup({top: _posX + _height + 20, left: _posY})
          setSuggestions(suggestions);
          
        } catch (error) {
          console.error('Error fetching suggestions:', error);
        }
      }
      setTimeout(() => {
          setAddressProcess(true)
        }, 1000)
    }
  };

  const handleSelectAddress = (address) => {
    setSelectedAddress(address);
    let res = checkAddress(address)
    if (res.error.length > 0) {
      setErrorAddress(res.error)
    } else {
      setErrorAddress('')
    }
    setSuggestions([]); // Очищаем список предложений после выбора адреса
  };

  const handleInputChangeAddressReg = async (type, target, address) => {
    if(['town', 'street', 'house'].includes(type)) {
      address[type] = target.value;
      setSelectedAddressReg(address);
      let res = checkAddress(selectedAddressReg)
      if (res.error.length > 0) {
        setErrorAddressReg(res.error)
      } else {
        setErrorAddressReg('')
      }
      const _address_all = (address?.town ? address.town + ', ' : '') + (address?.street ? address.street + ', ' : '') + (address?.house ? address.house : '')
      if (addressProcessReg) {
        setAddressRegProcess(false)
        try {
          const response = await axios.get('https://geocode-maps.yandex.ru/1.x/', {
            params: {
              apikey: 'cdfea19a-a15c-468e-a06f-79c567b491dc',
              geocode: _address_all,
              format: 'json'
            }
          });

          const { GeoObjectCollection } = response.data.response;
          const suggestions = GeoObjectCollection.featureMember.map(feature => {
            const { Address } = feature.GeoObject.metaDataProperty.GeocoderMetaData;
            const _value = {}
            for(const item of Address.Components) {
              if(addressPoles.includes(item.kind)) {
                _value[item.kind] = item.name
              }
            }
            return {
              value: {
                //region: _value?.country ?? '',
                town: (_value?.country ? _value?.country + (_value?.locality ? ', ' : '') : '') + (_value?.locality ? _value?.locality : ''),
                street: _value?.street ?? '',
                house: _value?.house ?? ''
              },
              label: (_value?.country ? _value?.country + ', ' : '') + (_value?.locality ? _value?.locality + ', ' : '') + (_value?.street ? _value?.street + ', ' : '') + (_value?.house ? _value?.house : '')
            };
          });
          let _height = target.offsetHeight;
          let _posX = target.offsetTop;
          let _posY = target.offsetLeft;
          setCoordPopupReg({top: _posX + _height + 20, left: _posY})
          setSuggestionsReg(suggestions);
        } catch (error) {
          console.error('Error fetching suggestions:', error);
        }
      }
      setTimeout(() => {
        setAddressRegProcess(true)
      }, 1000)
    }
  };

  const handleSelectAddressReg = (address) => {
    setSelectedAddressReg(address);
    let res = checkAddress(address)
    if (res.error.length > 0) {
      setErrorAddressReg(res.error)
    } else {
      setErrorAddressReg('')
    }
    setSuggestionsReg([]); // Очищаем список предложений после выбора адреса
  };

  const schemaPolicyForm = yup
    .object({
      middleName: yup
        .string()
        .matches(/^[А-ЯЁ][а-яё]+$/, 'Неверный формат данных')
        .required('Это обязательное поле'),
      firstName: yup
        .string()
        .matches(/^[А-ЯЁ][а-яё]+$/, 'Неверный формат данных')
        .required('Это обязательное поле'),
      lastName: yup
        .string()
        .matches(/^[А-ЯЁ][а-яё]+$/, 'Неверный формат данных')
        .required('Это обязательное поле'),
      whoGive: yup.string().required('Это обязательное поле'),
      dateGive: yup.date().required('Это обязательное поле')
    })
    .required()

  // setting form - inputs
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: {errors, isValid}
  } = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schemaPolicyForm)
  })

  const onChanges = async (data) => {
//    let checkAddress = watch('address')
    let res = checkAddress(selectedAddress)
    let finallyAddress = res.address ? res.address + (data?.corpusAddress ? ', корпус ' + data.corpusAddress : '') + (data?.apartmentAddress ? ', кв. ' + data.apartmentAddress : '') : ''
    // console.log(res);
    if (res.error.length > 0) {
       setErrorAddress(res.error)
    } else {
      setErrorAddress('')
    }
    let finallyAddressReg = ''
    if (reg === false) {
      res = checkAddress(selectedAddressReg)
      finallyAddressReg = res.address ? res.address + (data?.corpusAddressReg ? ', корпус ' + data.corpusAddressReg : '') + (data?.apartmentAddressReg ? ', кв. ' + data.apartmentAddressReg : '') : ''
      if (res.error.length > 0) {
        setErrorAddressReg(res.error)
      } else {
        setErrorAddressReg('')
      }
    } else {
      finallyAddressReg = finallyAddress
    }
    
    const obj = {
      positionId: null,
      positionName: null,
      firstName: data.firstName,
      middleName: data.middleName,
      lastName: data.lastName,
      passSerial: serial,
      passNumber: number,
      whoGive: data.whoGive,
      dateGive: data.dateGive,
      address: finallyAddress,
      addressReg: finallyAddressReg,
      town: res.town,
      email_access: email,
      type: 'POLICY',
      token: token,
    }
    
    // console.log(4)
    // console.log(obj);
    const json = JSON.stringify(obj)
    const blob = new Blob([json], {
      type: 'application/json'
    })

    let saveRequest = new FormData()
    saveRequest.append('saveRequest', blob)

    serial.length < 5 && setErrorSerial(true)
    number.length < 6 && setErrorNumber(true)
    !success && setBlurSuccess(true)

    let _protocol = window.location.protocol
    // console.log(4)
    // console.log(serial, number, success)
    if (serial.length===5 && number.length===6 && success) {
      try {
        axios({
          method: 'post',
          url: `${_protocol}//${checkDomenNameState}/api/v1/response/save`,
          data: saveRequest,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
          if (response.data.status != "error") {
            setSuccessSend(true)
            reset()
            setNumber('')
            setSerial('')
          } else {
            let _error = <>{parse(response.data.message)}</>
            toast.error(_error);
          }
        })
      } catch (e) {
        toast.error('Отклик не отправился!')
      } finally {
        setSuccess(false)
        setBlurSuccess(false)
        setReg(false)
        setErrorNumber(false)
        setErrorSerial(false)
        setErrorAddress('')
        setErrorAddressReg('')
      }
    }
  }

  function checkAddress(address) {
    let error = ''
    for (const pole in address) {
      if(address[pole]=='') {
        error = 'Неточный адрес, требуется уточнение'
      }
    }
    return ({
      error: error,
      town: address.town,
      address: (address?.town ? address?.town + ', ' : '') + (address?.street ? address?.street + ', ' : '') + (address?.house ? address?.house : '')
    })
  }

  return (
    <div>
      <form className={styles.form_block_listing_wrapper} onSubmit={handleSubmit(onChanges)}>
        <p className={styles.form_block_listing_subtitle}>Личные данные</p>
        <div className={styles.form_block_wrapper}>
          <div
            className={errors.middleName?.message ? styles.form_block_listing_item_error : styles.form_block_listing_item}>
            <label htmlFor='middleName'>Фамилия</label>
            <input
              {...register('middleName')}
              placeholder='Иванов'
              type='text'
              name='middleName'
              maxLength='50'
              className='placeholder-gray-400'
            />
            {errors?.middleName && <p className={styles.left_input_error}>{errors.middleName?.message}</p>}
          </div>

          <div
            className={errors.firstName?.message ? styles.form_block_listing_item_error : styles.form_block_listing_item}>
            <label htmlFor='firstName'>Имя</label>
            <input
              {...register('firstName')}
              placeholder='Иван'
              type='text'
              name='firstName'
              maxLength='50'
              className='placeholder-gray-400'
            />
            {errors?.firstName && <p className={styles.left_input_error}>{errors.firstName?.message}</p>}
          </div>

          <div
            className={errors.lastName?.message ? styles.form_block_listing_item_error : styles.form_block_listing_item}>
            <label htmlFor='lastName'>Отчество</label>
            <input
              {...register('lastName')}
              placeholder='Иванович'
              type='text'
              name='lastName'
              maxLength='50'
              className='placeholder-gray-400'
            />
            {errors?.lastName && <p className={styles.left_input_error}>{errors.lastName?.message}</p>}
          </div>
        </div>

        <p className={styles.form_block_listing_subtitle}>Паспортные данные</p>
        <div className={styles.form_block_wrapper}>
          <div className={styles.form_block_wrapper3}>
            <div
              className={
                errorSerial && serial?.length !== 4
                  ? styles.form_block_listing_item3_error
                  : styles.form_block_listing_item3
              }
            >
              <label htmlFor='serial'>Серия паспорта</label>
              <InputMask
                mask="99 99"
                value={serial}
                onChange={e => setSerial(e.target.value)}
                className="placeholder-gray-400"
                label="serial"
                autoComplete="off"
                placeholder="71 11"
              >
              </InputMask>
              {errorSerial && serial?.length !== 4 &&
                <p className={styles.left_input_error}>Неверный формат серии</p>}
              {errorSerial && serial?.length === 0 &&
                <p className={styles.left_input_error}>Это обязательное поле</p>}
            </div>

            <div
              className={
                errorNumber && number?.length !== 6
                  ? styles.form_block_listing_item3_error
                  : styles.form_block_listing_item3
              }
            >
              <label htmlFor='number'>Номер паспорта</label>
              <InputMask
                mask="999999"
                value={number}
                onChange={e => setNumber(e.target.value)}
                className="placeholder-gray-400"
                label="number"
                autoComplete="off"
                placeholder="000000"
              >
              </InputMask>
              {errorNumber && number?.length < 6 && number?.length !== 0 &&
                <p className={styles.left_input_error}>Неверный формат номера</p>}
              {errorNumber && number?.length === 0 &&
                <p className={styles.left_input_error}>Это обязательное поле</p>}
            </div>

            <div
              className={errors.dateGive?.message ? styles.form_block_listing_item3_error : styles.form_block_listing_item3}
            >
              <label htmlFor='dateGive'>Когда выдан</label>
              <input
                {...register('dateGive')}
                placeholder='03.07.2010'
                type='date'
                name='dateGive'
                maxLength='50'
                className='placeholder-gray-400'/>
              {errors?.dateGive && <p className={styles.left_input_error}>{errors.dateGive?.message}</p>}
            </div>
          </div>

          <div className={styles.form_block_wrapper_all}>
            <div
              className={errors.whoGive?.message ? styles.form_block_listing_item_error : styles.form_block_listing_item}
            >
              <label htmlFor='whoGive'>Кем выдан паспорт</label>
              <input
                {...register('whoGive')}
                placeholder=''
                type='text'
                name='whoGive'
                maxLength='50'
                className='placeholder-gray-400'/>
              {errors?.whoGive && <p className={styles.left_input_error}>{errors.whoGive?.message}</p>}
            </div>
          </div>
        </div>

        <p className={styles.form_block_listing_subtitle}>Адрес проживания</p>
        <div className={styles.form_block_wrapper}>
          <div
            className={errorAddress!='' ? styles.form_block_listing_item_error : styles.form_block_listing_item}>
            <label htmlFor='townAddress'>Город</label>
            <input
              placeholder='Нижний-Новгород'
              type='text'
              name='townAddress'
              maxLength='50'
              className='placeholder-gray-400'
              value={selectedAddress.town}
              onChange={(e) => handleInputChangeAddress('town', e.target, {...selectedAddress})}
            />
            {errorAddress!='' && <p className={styles.left_input_error}>{errorAddress}</p>}
          </div>
          {/* Выводим выпадающий список найденных адресов */}
          <div
            className={errorAddress!='' ? styles.form_block_listing_item_error : styles.form_block_listing_item}>
            <label htmlFor='streetAddress'>Улица</label>
            <input
              {...register('streetAddress')}
              placeholder='Ленина'
              type='text'
              name='streetAddress'
              maxLength='50'
              className='placeholder-gray-400'
              value={selectedAddress.street}
              onChange={(e) => handleInputChangeAddress('street', e.target, {...selectedAddress})}
            />
          </div>
          <div className={styles.form_block_wrapper3}>
            <div
              className={errorAddress!='' ? styles.form_block_listing_item3_error : styles.form_block_listing_item3}
            >
              <label htmlFor='houseAddress'>Дом</label>
              <input
                {...register('houseAddress')}
                placeholder='37A'
                type='text'
                maxLength='10'
                name='houseAddress'
                className='placeholder-gray-400'
                value={selectedAddress.house}
                onChange={(e) => handleInputChangeAddress('house', e.target, {...selectedAddress})}
              />

            </div>
            <div
              className={styles.form_block_listing_item3}
            >
              <label htmlFor='corpusAddress'>Корпус</label>
              <input
                {...register('corpusAddress')}
                placeholder='2K'
                type='text'
                maxLength='10'
                name='corpusAddress'
                className='placeholder-gray-400'/>
            </div>
            <div
              className={styles.form_block_listing_item3}
            >
              <label htmlFor='apartmentAddress'>Квартира</label>
              <input
                {...register('apartmentAddress')}
                placeholder='115'
                type='number'
                inputMode="numeric"
                name='apartmentAddress'
                min='1'
                maxLength='5'
                pattern="[1-9][0-9]*"
                className='placeholder-gray-400'/>
            </div>

          </div>
          {suggestions.length > 0 && (
            <div className={styles.form_block_listing_yamap_popup} style={stylePositionPopup(coordPopup)}>
              <div className={styles.form_block_listing_yamap_popup_close} onClick={() => setSuggestions([])}>x</div>
              {suggestions.map((address, index) => (
                <div className={styles.form_block_listing_yamap_popup_item} key={index} onClick={() => handleSelectAddress(address.value)}>
                  {address.label}
                </div>
              ))}
            </div>
          )}
        </div>
        <p className={styles.form_block_listing_subtitle}>Адрес регистрации</p>
        <div
          className={
            !reg ? styles.form_block_listing_checkbox_reg_error : styles.form_block_listing_checkbox_reg
          }
        >
          <input value={reg} onClick={(e) => {
            e.stopPropagation();
            $('ymaps').remove()
            setReg(!reg)
          }
          } type='checkbox' id='reg' name='reg' className={styles.reg}/>
          <label htmlFor='reg'></label>
          <p>
            Совпадает с местом проживания
          </p>
        </div>
        {reg === false && (
          <div className={styles.form_block_wrapper}>
            <div
              className={errorAddressReg!='' ? styles.form_block_listing_item_error : styles.form_block_listing_item}>
              <label htmlFor='townAddressReg'>Город</label>
              <input
                placeholder='Нижний-Новгород'
                type='text'
                name='townAddressReg'
                maxLength='50'
                className='placeholder-gray-400'
                value={selectedAddressReg.town}
                onChange={(e) => handleInputChangeAddressReg('town', e.target, {...selectedAddressReg})}
              />
              {errorAddressReg!='' && <p className={styles.left_input_error}>{errorAddressReg}</p>}
            </div>
            {/* Выводим выпадающий список найденных адресов */}
            <div
              className={errorAddressReg!='' ? styles.form_block_listing_item_error : styles.form_block_listing_item}>
              <label htmlFor='streetAddressReg'>Улица</label>
              <input
                {...register('streetAddressReg')}
                placeholder='Ленина'
                type='text'
                name='streetAddressReg'
                maxLength='50'
                className='placeholder-gray-400'
                value={selectedAddressReg.street}
                onChange={(e) => handleInputChangeAddressReg('street', e.target, {...selectedAddressReg})}
              />
            </div>
            <div className={styles.form_block_wrapper3}>
              <div
                className={errorAddressReg!='' ? styles.form_block_listing_item3_error : styles.form_block_listing_item3}
              >
                <label htmlFor='houseAddressReg'>Дом</label>
                <input
                  {...register('houseAddressReg')}
                  placeholder='37A'
                  type='text'
                  maxLength='10'
                  name='houseAddressReg'
                  className='placeholder-gray-400'
                  value={selectedAddressReg.house}
                  onChange={(e) => handleInputChangeAddressReg('house', e.target, {...selectedAddressReg})}
                />

              </div>
              <div
                className={styles.form_block_listing_item3}
              >
                <label htmlFor='corpusAddressReg'>Корпус</label>
                <input
                  {...register('corpusAddressReg')}
                  placeholder='2K'
                  type='text'
                  maxLength='10'
                  name='corpusAddressReg'
                  className='placeholder-gray-400'/>
              </div>
              <div
                className={styles.form_block_listing_item3}
              >
                <label htmlFor='apartmentAddressReg'>Квартира</label>
                <input
                  {...register('apartmentAddressReg')}
                  placeholder='115'
                  type='number'
                  inputMode="numeric"
                  name='apartmentAddressReg'
                  min='1'
                  maxLength='5'
                  pattern="[1-9][0-9]*"
                  className='placeholder-gray-400'/>
              </div>

            </div>
            {suggestionsReg.length > 0 && (
              <div className={styles.form_block_listing_yamap_popup} style={stylePositionPopup(coordPopupReg)}>
                <div className={styles.form_block_listing_yamap_popup_close} onClick={() => setSuggestionsReg([])}>x</div>
                {suggestionsReg.map((address, index) => (
                  <div className={styles.form_block_listing_yamap_popup_item} key={index}
                       onClick={() => handleSelectAddressReg(address.value)}>
                    {address.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        <div
          className={
            !success && blurSuccess ? styles.form_block_listing_checkbox_error : styles.form_block_listing_checkbox
          }
        >
          <input value={success} onClick={(e) => {
            e.stopPropagation()
            setSuccess(!success)
            if (success && blurSuccess) {
              setBlurSuccess(false)
            }
            handleButtonClick()
          }
          } type='checkbox' id='agreement' name='agreement' className={styles.agreement}/>
          <label htmlFor='agreement'></label>
          <p>
            Я даю согласие на{' '}
            <a href='/privacy-policy' target='_blank'>
              <span onClick={() => setActiveForm(false)}>обработку моих персональных данных</span>
            </a>{' '}
          </p>
          {success === false && blurSuccess === true && (
            <p className={styles.left_input_error}>Эта галочка обязательна!</p>
          )}
        </div>

        <InvisibleSmartCaptcha
          sitekey={captchaSiteKey}
          onSuccess={setToken}
          onChallengeHidden={handleChallengeHidden}
          visible={visible}
        />

        <button
          className={styles.form_block_listing_btn_active}
        >
          Отправить заявку
          <span>&rarr;</span>
        </button>
      </form>
    </div>
  )
}

export default FormAcceptPolicy
